import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'
import { isApiError } from '~/api/client'
import { Toaster } from '~/components/ui/toaster'
import { Theme } from '~/theme/Theme'

/** Mirrors vocdoni-app createAppQueryClient: no retries on 4xx, short stale time. */
export const createAppQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false
          return failureCount < 2
        },
      },
      mutations: { retry: false },
    },
  })

const queryClient = createAppQueryClient()

export const Providers = ({ children }: PropsWithChildren) => (
  <QueryClientProvider client={queryClient}>
    <Theme>
      {children}
      <Toaster />
    </Theme>
  </QueryClientProvider>
)
